import VanillaUtils from 'frontools/utils/VanillaUtils';

export class ScrollTo {

    constructor(private _el: HTMLElement){
        if (this._el){
            let offsetHeader = (document.querySelector('[data-main-nav]') as HTMLElement).clientHeight + 15;
            // ScrollUtils.scrollTo({
            //     offset: offsetHeader,
            //     target: this._el, 
            //     speed: 0.7,
            //     // easing: Expo.easeOut, //Linear.easeNone
            //     easing: Linear.easeNone
            // });
            TweenLite.to(window, 0.4, {scrollTo: {y: VanillaUtils.getOffsetRect(this._el).top - offsetHeader, autoKill: false}, ease:Power2.easeInOut});
        }

    }
}